/** Базовый URL HTTP API. */
export function getApiUrl(): string {
  const raw = (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '');
  if (raw === 'http://localhost:3001' || raw === 'http://127.0.0.1:3001') {
    return '/api';
  }
  return raw;
}

/** URL WebSocket сессии на том же хосте, что и страница. */
export function getWsUrl(): string {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}/ws`;
}
